module.exports = __webpack_public_path__ + "img/街镇报名点@2x.b84ee515.png";